import { useFetch } from "~vue/api";
import type { GetLabInsightFeedbackResponse, LabInsightFeedbackResponse, SubmitLabInsightFeedbackRequest, UpdateLabInsightFeedbackTagsRequest } from "~vue/types/labs";
import { computed, ref } from "vue";

export function useLabInsightFeedback(insightId: string) {
    const feedbackUrl = computed(() => `/api/labs/feedback/${insightId}`);
    const {
        data: feedbackData,
        error: fetchError,
        isFetching: feedbackFetching,
        execute: fetchFeedback,
    } = useFetch(feedbackUrl, { immediate: false }).get().json<GetLabInsightFeedbackResponse>();

    const feedbackSubmitPayload = ref<SubmitLabInsightFeedbackRequest | null>(null);
    const {
        data: submittedFeedback,
        error: submitError,
        isFetching: feedbackSubmitting,
        execute: _submitFeedback,
    } = useFetch("/api/labs/feedback/", { immediate: false }).post(feedbackSubmitPayload).json<LabInsightFeedbackResponse>();

    async function submitFeedback(payload: SubmitLabInsightFeedbackRequest) {
        feedbackSubmitPayload.value = payload;
        await _submitFeedback();
        feedbackSubmitPayload.value = null;
        if (!submitError.value) {
            await fetchFeedback();
            return submittedFeedback?.value ?? undefined;
        }
    }

    const tagsPayload = ref<UpdateLabInsightFeedbackTagsRequest | null>(null);
    const {
        error: tagsError,
        isFetching: tagsSubmitting,
        execute: _submitTags,
    } = useFetch("/api/labs/feedback/tags/", { immediate: false }).patch(tagsPayload).json<LabInsightFeedbackResponse>();

    async function submitTags(tags: string[]) {
        tagsPayload.value = { insight_id: insightId, tags };
        await _submitTags();
        tagsPayload.value = null;
        if (!tagsError.value) {
            await fetchFeedback();
        }
    }

    return {
        feedbackData,
        feedbackFetching,
        feedbackSubmitting,
        feedbackSubmitPayload,
        fetchFeedback,
        submitFeedback,
        tagsSubmitting,
        tagsError,
        submitTags,
        fetchError,
        submitError,
    };
}
